import { initialPageState, IPageState } from '../state/page.state';
import {PageActions, EPageActions, PageErrorPage, PageCoverVideo} from '../actions/page.actions';
import {IPlayremainders} from '../../models/playremainders.interface';

export const pageReducers = (state = initialPageState, action: PageActions): IPageState => {
  switch (action.type) {
    case EPageActions.PageLoadingHide: {
      return {
        ...state,
        page: {
          ...state.page,
          loading: false,
        },
      };
    }
    case EPageActions.PageLoadingShow: {
      return {
        ...state,
        page: {
          ...state.page,
          loading: true,
        },
      };
    }
    case EPageActions.PageLoadingMenuHide: {
      return {
        ...state,
        page: {
          ...state.page,
          loadingMenu: false,
        },
      };
    }
    case EPageActions.PageLoadingMenuShow: {
      return {
        ...state,
        page: {
          ...state.page,
          loadingMenu: true,
        },
      };
    }
    case EPageActions.PagePlaceSelect: {
      return {
        ...state,
        page: {
          ...state.page,
          placeSelected: action.payload,
        },
      };
    }
    case EPageActions.PagePlaceSelectStart: {
      if (state.page.placeSelected === '') {
        return {
          ...state,
          page: {
            ...state.page,
            placeSelected: action.payload,
          },
        };
      } else {
        return state;
      }
    }
    case EPageActions.PageFullSreen: {
      return {
        ...state,
        page: {
          ...state.page,
          fullScreen: !state.page.fullScreen,
        },
      };
    }
    case EPageActions.PageShowMenu: {
      return {
        ...state,
        page: {
          ...state.page,
          showMenu: action.payload ? action.payload : !state.page.showMenu,
          showCart: state.page.showCart ? !state.page.showCart : state.page.showCart,
          showLast: state.page.showLast ? !state.page.showLast : state.page.showLast,
          showBonus: state.page.showBonus ? !state.page.showBonus : state.page.showBonus,
        },
      };
    }
    case EPageActions.PageShowCart: {
      return {
        ...state,
        page: {
          ...state.page,
          showLast: state.page.showLast ? !state.page.showLast : state.page.showLast,
          showMenu: state.page.showMenu ? !state.page.showMenu : state.page.showMenu,
          showBonus: state.page.showBonus ? !state.page.showBonus : state.page.showBonus,
          showCart: !state.page.showCart,
        },
      };
    }
    case EPageActions.PageShowLast: {
      return {
        ...state,
        page: {
          ...state.page,
          showMenu: state.page.showMenu ? !state.page.showMenu : state.page.showMenu,
          showCart: state.page.showCart ? !state.page.showCart : state.page.showCart,
          showBonus: state.page.showBonus ? !state.page.showBonus : state.page.showBonus,
          showLast: !state.page.showLast
        },
      };
    }
    case EPageActions.PageShowBonus: {
      return {
        ...state,
        page: {
          ...state.page,
          showMenu: state.page.showMenu ? !state.page.showMenu : state.page.showMenu,
          showCart: state.page.showCart ? !state.page.showCart : state.page.showCart,
          showLast: state.page.showLast ? !state.page.showLast : state.page.showLast,
          showBonus: !state.page.showBonus
        },
      };
    }
    case EPageActions.PageAddSession: {
      return {
        ...state,
        page: {
          ...state.page,
          session: action.payload,
        },
      };
    }
    case EPageActions.PageAddCID: {
      return {
        ...state,
        page: {
          ...state.page,
          cid: action.payload,
        },
      };
    }
    case EPageActions.PageAddFirstStreaming: {
      return {
        ...state,
        page: {
          ...state.page,
          firstStreaming: action.payload,
        },
      };
    }
    case EPageActions.PageSetPlayerRace: {
      return {
        ...state,
        page: {
          ...state.page,
          playerRace: action.payload,
        },
      };
    }
    case EPageActions.PageGetIpSuccess: {
      return {
        ...state,
        page: {
          ...state.page,
          ip: action.payload.ip,
        },
      };
    }
    case EPageActions.PageAddLogo: {
      return {
        ...state,
        page: {
          ...state.page,
          urllogo: action.payload,
        },
      };
    }
    case EPageActions.PageAddImagesHome: {
      return {
        ...state,
        page: {
          ...state.page,
          imageshome: action.payload,
        },
      };
    }
    case EPageActions.PageAddImagesCart: {
      return {
        ...state,
        page: {
          ...state.page,
          imagescart: action.payload,
        },
      };
    }
    case EPageActions.PageAddTrackGA: {
      return {
        ...state,
        page: {
          ...state.page,
          trackGA: action.payload,
        },
      };
    }
    case EPageActions.PageAddVideoEnabled: {
      return {
        ...state,
        page: {
          ...state.page,
          videoEnabled: action.payload,
        },
      };
    }

    case EPageActions.PageAddPlayVideo: {
      return {
        ...state,
        page: {
          ...state.page,
          playVideo: action.payload,
        },
      };
    }
    case EPageActions.PageAddDisableAudio: {
      return {
        ...state,
        page: {
          ...state.page,
          disableaudio: action.payload,
        },
      };
    }
    case EPageActions.PageAddShowTicketList: {
      return {
        ...state,
        page: {
          ...state.page,
          showTicketList: action.payload,
        },
      };
    }
    case EPageActions.PageAddFunctionCompleteBet: {
      return {
        ...state,
        page: {
          ...state.page,
          functionCompleteBet: action.payload,
        },
      };
    }
    case EPageActions.PageAddFunctionButtonBet: {
      return {
        ...state,
        page: {
          ...state.page,
          functionButtonBet: action.payload,
        },
      };
    }
    case EPageActions.PageSetCartTabIndex: {
      return {
        ...state,
        page: {
          ...state.page,
          cartTabIndex: action.payload,
        },
      };
    }
    case EPageActions.PageSetMenuTabIndex: {
      return {
        ...state,
        page: {
          ...state.page,
          menuTabIndex: action.payload,
        },
      };
    }
    case EPageActions.PageSetCountryMenu: {
      return {
        ...state,
        page: {
          ...state.page,
          countryMenu: action.payload,
        },
      };
    }
    case EPageActions.PageSetTypeMenu: {
      return {
        ...state,
        page: {
          ...state.page,
          typeMenu: action.payload
        }
      };
    }
    case EPageActions.PageSetSystemBetMenu: {
      return {
        ...state,
        page: {
          ...state.page,
          systemBetMenu: action.payload
        }
      };
    }
    case EPageActions.PageSetOpenRace: {
      return {
        ...state,
        page: {
          ...state.page,
          openRace: action.payload
        }
      };
    }
    case EPageActions.PageSetOpenNoOddRace: {
      return {
        ...state,
        page: {
          ...state.page,
          openNoOddRace: action.payload
        }
      };
    }
    case EPageActions.PageSetCloseRace: {
      return {
        ...state,
        page: {
          ...state.page,
          closeRace: action.payload
        }
      };
    }
    case EPageActions.PageSetFreebetSingle: {
      return {
        ...state,
        page: {
          ...state.page,
          freebetSingle: action.payload,
        },
      };
    }
    case EPageActions.PageSetFreebetMultiple: {
      return {
        ...state,
        page: {
          ...state.page,
          freebetMultiple: action.payload,
        },
      };
    }
    case EPageActions.PageSetFreebetSystem: {
      return {
        ...state,
        page: {
          ...state.page,
          freebetSystem: action.payload,
        },
      };
    }
    case EPageActions.PageSetBonusSingle: {
      return {
        ...state,
        page: {
          ...state.page,
          bonusSingle: action.payload,
        },
      };
    }
    case EPageActions.PageSetBonusMultiple: {
      return {
        ...state,
        page: {
          ...state.page,
          bonusMultiple: action.payload,
        },
      };
    }
    case EPageActions.PageSetBonusSystem: {
      return {
        ...state,
        page: {
          ...state.page,
          bonusSystem: action.payload,
        },
      };
    }
    case EPageActions.PageSetCountRaceMenu: {
      return {
        ...state,
        page: {
          ...state.page,
          count: action.payload
        },
      };
    }
    case EPageActions.PageReminderBetsSuccess: {
      let payload: IPlayremainders = action.payload;
      // console.log(action.events);
      // console.log(action.payload);
      // console.log(state.page.reminder);
      // console.log(state.page.reminder.giocata.filter((s) => s.scommessa === '13').length > 0);
      if (
          // (action.events && action.payload && action.payload.giocata && action.payload.giocata.length > 0) &&
          (action.events && state.page.reminder && state.page.reminder.giocata && state.page.reminder.giocata.filter((s) => s.scommessa === '13').length > 0)
      ) {
        if (action.payload && action.payload.giocata && action.payload.giocata.length > 0) {

          const idBigliettoState = state.page.reminder.giocata.map((giocata) => giocata.id_biglietto );
          const idBigliettoPayload = action.payload.giocata.map((giocata) => giocata.id_biglietto );
          const idBiglietto = idBigliettoPayload.filter((id) => idBigliettoState.indexOf(id) < 0);
          const result = action.payload.giocata.filter((giocata) => idBiglietto.includes(giocata.id_biglietto));

          state.page.reminder.giocata = state.page.reminder.giocata.concat(result);
          payload = state.page.reminder;
        }
      }
      // console.log('state', state.page.reminder);
      // console.log('pay', payload);
      return {
        ...state,
        page: {
          ...state.page,
          // reminder: action.payload
          reminder: payload
        },
      };
    }
    case EPageActions.PageReminderBetsReset: {
      return {
        ...state,
        page: {
          ...state.page,
          reminder: {
            giocata: []
          }
        },
      };
    }
    case EPageActions.PageSetFavorite: {
      return {
        ...state,
        page: {
          ...state.page,
          favorites: action.payload
        },
      };
    }
    case EPageActions.PageSetHidefullstats: {
      return {
        ...state,
        page: {
          ...state.page,
          hidefullstats: action.payload
        },
      };
    }
    case EPageActions.PageSetTerminalTag: {
      return {
        ...state,
        page: {
          ...state.page,
          terminalTag: action.payload
        },
      };
    }
    case EPageActions.PageErrorPage: {
      return {
        ...state,
        page: {
          ...state.page,
          errorPage: action.payload
        },
      };
    }
    case EPageActions.PageConfirmBetState: {
      return {
        ...state,
        page: {
          ...state.page,
          confirmBetState: action.payload
        },
      };
    }
    case EPageActions.PageCoverVideo: {
      return {
        ...state,
        page: {
          ...state.page,
          coverVideo: state.page.coverVideo === 'assets/img/screen-video-horse-en.png' ? action.payload : state.page.coverVideo
        },
      };
    }

    case EPageActions.PageToday: {
      return {
        ...state,
        page: {
          ...state.page,
          today: action.payload
        },
      };
    }
    default:
      return state;
  }
};
